import { createFileRoute } from '@tanstack/react-router';
import { TransactionalSentRoute } from '@/pages/workspaces/transactional/message/overview/sent/routing';

function TransactionalSentIndexRoute() {
  const { transactionalMessageId } = Route.useParams();
  return <TransactionalSentRoute transactionalMessageId={transactionalMessageId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/sent/',
)({
  component: TransactionalSentIndexRoute,
});
